import { render } from "./AppTopbar.vue?vue&type=template&id=7b9741e9"
import script from "./AppTopbar.vue?vue&type=script&lang=js"
export * from "./AppTopbar.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Public\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__